(function() {
    const ContoAddebitoService = function(
        $http,
        CONSTANTS
    ) {
        this.listiniMito = [];
        this.categorieUtente = [];

        this.getListinoMto = () => {
            return $http({
                method: 'GET',
                url: '/MSF-PROSPECTMANAGER-MF/api/NaturalPerson/GetMitoProducts',
                params: { sopprimiCanale: true }
            });
        };

        this.getCategorieUtente = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT +
                    CONSTANTS.REST.DOMINI.CATEGORIA_UTENTE +
                    codiceMito
            });
        };

        this.getContiAddebito = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT +
                    CONSTANTS.REST.MITO.CONTI_ADDEBITO +
                    codiceMito
            });
        };

        this.getContiDisponibili = (ndg) => {
            return $http({
                method: 'GET',
                url: '/MSF-OFFERMANAGER-MF/api/TimeDeposit/GetCurrentAccountListRecursive',
                params: { ndg: ndg }
            });
        };
    };

    ContoAddebitoService.$inject = [
        '$http',
        'Mitom_CONSTANTS'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomContoAddebitoService', ContoAddebitoService);
})();